import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, NgForm } from '@angular/forms';
import { RechteSelection } from '../../../core/gb-api';
import { CapFormControlComponent } from '../../form-control/form-control.component';
import { MetaDisablerDirective } from '../../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-rechte-selection',
  templateUrl: './rechte-selection.component.html',
  styleUrls: ['./rechte-selection.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RechteSelectionComponent), multi: true }],
  imports: [CapFormControlComponent, FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class RechteSelectionComponent implements ControlValueAccessor {
  @ViewChild(NgForm, { static: false })
  form: NgForm;

  @Input() heading = 'Typ';

  showArtGrundpfandrecht = true;

  model: RechteSelection;
  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  constructor() {}

  @Input()
  set mitArtGrundpfandrecht(value: boolean) {
    if (value === null || value === undefined) {
      return;
    }
    this.showArtGrundpfandrecht = value;
  }

  writeValue(obj: any): void {
    this.model = obj;
    if (!this.showArtGrundpfandrecht && this.model) {
      this.model.sucheGrundpfandrecht = false;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }
}
